import { ref } from 'vue';
import { groupCollectionsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';
import type { ClientContext } from '~/services/contextClient';

export const useGroupCollectionsGroupsCount = createGlobalState(() => {
    // [groupCollectionId]: groupsCount
    // undefined = loading
    // null = not found
    const groupCounts = ref<Record<number, number>>({});

    const fetching = ref(false);

    const fetchGroupCollectionsGroupsCount = async (
        context: Omit<ClientContext, 'groupId'>,
        groupCollectionIds: number[]
    ) => {
        // remove existing ids to avoid computing them again
        groupCollectionIds = groupCollectionIds.filter((groupCollectionId) => !groupCounts.value[groupCollectionId]);

        if (!groupCollectionIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchGroupCollectionsGroupsCount(context, groupCollectionIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            for (let i = 0; i < groupCollectionIds.length; i += 10) {
                const batch = groupCollectionIds.slice(i, i + 10);
                const response = await groupCollectionsClient.getGroupCollectionsGroupCounts(context, {
                    group_collection_ids: batch,
                });

                Object.entries(response.data.counts).forEach(([id, count]) => {
                    groupCounts.value[Number(id)] = count ?? 0;
                });
            }
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchGroupCollectionsGroupsCount,
        groupCounts,
    };
});
